/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState, forwardRef } from "react";
import Select from "react-select";
// import AddStores from "./addstore.jsx";
import {
  APIgetRoles,
  addUser,
  updateUserPassword,
  setUserLocations,
} from "../../../api/settings.ts";
// import { APIGetUserLocations } from "../../../api/stores.ts";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelector } from "react-redux";
import AddStoresModal from "./AddStoresModal.jsx";
import { IoClose } from "react-icons/io5";
//import axios from "axios";
// eslint-disable-next-line react/display-name
const AddUsers = forwardRef(({ refetchUser }) => {
  const translation = useSelector(state => state.root.translation);
  const MySwal = withReactContent(Swal);
  const [formDataList, setFormData] = useState({});

  const [allRoles, setAllRoles] = useState([]);
  const [dataRole, setDataRole] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  //  const [showAddStoresModal, setShowAddStoresModal] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({}); // State for storing form errors
  const inputRefs = useRef({});
  const [isModalOpen, setModalOpen] = useState(false);
  const [storesData, setStoresData] = useState([]);
  const [checkboxData, setCheckboxData] = useState({});

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);
  const handleSelectStores = (selectedStores) => {
    selectedStores?.forEach(item => {
      handleCheckboxChange(item.storeCode , 'oversees')
    })
    setStoresData(selectedStores);
  };

  //
  const getRolesApi = async () => {
    const res = await APIgetRoles({});
    if (res?.response?.roles) {
      const roleData = res.response.roles;
      const role = roleData.map((item) => {
        return { label: item.title, value: item._id };
      });
      setDataRole(role);
      setAllRoles(roleData);
    }
  };
  useEffect(() => {
    getRolesApi();
    setFormData({});
    setFormErrors({});
  }, []);

  useEffect(() => {
    const handleModalOpen = () => {
      setFormData({});
      setFormErrors({});
    };

    document
      .getElementById("add-users")
      ?.addEventListener("show.bs.modal", handleModalOpen);

    return () => {
      document
        .getElementById("add-users")
        ?.removeEventListener("show.bs.modal", handleModalOpen);
    };
  }, []);

  //
  const handleTogglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleToggleConfirmPassword = () => {
    setShowConfirmPassword((prevShowPassword) => !prevShowPassword);
  };
  const removeMethod = async (id) => {
    // const userId = localStorage.getItem("userId");
    // try {
    //   const res = await unassignUserStore({storeId:id.value, userId:userId});
    //   if(res){
    const stores = storesData.filter((item) => item.value !== id.value);
    const n = {};
    Object.keys(checkboxData)?.forEach((key) => {
      n[key] = checkboxData[key].filter((item) => item != id.storeCode);
    });
    setCheckboxData(n);
    setStoresData(stores);
    // }
    // } catch (error) {
    //   console.log(error)
    // }
  };
  const handleInputChange = (e) => {
    var { name, value } = e.target;
    if (name === "shiftEndTime" && value < formDataList.shiftStartTime) {
      // // Optionally, reset to start time or show an error message
      // alert("End time cannot be less than start time.");
      // return; // Prevent updating the state if the end time is less than start time
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        shiftEndTime: "End time cannot be less than start time.",
      }));
      return;
    }
    console.log("value", value);
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name == "selectedRole") {
      const find = allRoles.find((item) => item._id == value);
      console.log("find", find);
    }
    setFormErrors({ ...formErrors, [name]: "" });
  };
  //
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);

    formErrors.password = "";
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    if (e.target.value !== password) {
      // setError("Passwords do not match");
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: "Passwords do not match.",
      }));
    } else {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: null,
      }));
    }
    formErrors.confirmPassword = "";
  };

  const updatePassword = async (id) => {
    let userDetails = {
      id: id,
      password: password,
      newConfirmPassword: confirmPassword,
    };
    const upRes = await updateUserPassword(userDetails);
    return upRes;
  };
  useEffect(() => {
    const handleModalOpen = () => {
      setFormData({});
      setPassword("");
      setConfirmPassword("");
      setError("");
    };

    document
      .getElementById("add-users")
      ?.addEventListener("show.bs.modal", handleModalOpen);

    return () => {
      document
        .getElementById("add-users")
        ?.removeEventListener("show.bs.modal", handleModalOpen);
    };
  }, []);
  const submit = async (event) => {
    event.preventDefault();
    const errors = {};

    if (!formDataList.firstname) {
      errors.firstname = "First Name is required.";
    }

    if (!formDataList.username) {
      errors.username = "Username is required.";
    }
    if (!/\S+@\S+\.\S+/.test(formDataList.email)) {
      errors.email = "Invalid email format";
    }
    if (!formDataList.email) {
      errors.email = "Email is required.";
    }
    if (!password) {
      errors.password = "Password is required.";
    }
    if (password !== confirmPassword) {
      errors.confirmPassword = "Passwords do not match.";
    }
    if (!confirmPassword) {
      errors.confirmPassword = "Confirm password is required.";
    }

    // Validation
    if (!formDataList.selectedRole) {
      errors.selectedRole = "Role is required.";
    }

    // If there are errors, don't proceed
    // if (Object.keys(errors).length > 0) {
    //   console.log('test');
    //   setFormErrors(errors);
    //    // Focus on the first input field with an error
    //    const firstErrorField = Object.keys(errors)[0];
    //    console.log('test-firstErrorField',firstErrorField);
    //    const firstErrorElement = document.querySelector(`[name=${firstErrorField}]`);
    //    console.log('firstErrorElement',firstErrorElement);
    //    if (firstErrorElement) {
    //      firstErrorElement.focus();
    //    }
    //    return;
    // }
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);

      // Focus on the first input field with an error using inputRefs
      const firstErrorField = Object.keys(errors)[0];
      if (inputRefs.current[firstErrorField]) {
        inputRefs.current[firstErrorField].focus();
      }
      return;
    }

    if (!formDataList.selectedRole) {
      alert("Role Not Selected");
      return;
    }
    //
    let userUpdatedProfile = {
      firstName: formDataList.firstname,
      lastName: formDataList.lastname,
      username: formDataList.username,
      password: password,
      roleId: formDataList.selectedRole,
      email: formDataList.email,
      skillSets: formDataList.skillSets, // hashed and split skillsets
      jobTitle: formDataList.jobTitle,
      jobResponsibilities: formDataList.jobResponsibilities,
      linkedinProfile: formDataList.linkedinProfile,
      jobExperience: formDataList.jobExperience,
      shiftStartTime: formDataList.shiftStartTime,
      shiftEndTime: formDataList.shiftEndTime,
      toAdd: true,
    };

    {
      if (password != confirmPassword) {
        alert("Password Not Matched");
        return;
      }
      try {
        setBtnLoading(true);
        const res = await addUser(userUpdatedProfile);
        const id = res.response.users[0]._id;
        // const loc = await setLocation(id);
        await setUserLocation(id);
        const upPass = await updatePassword(id);
        if (upPass) {
          document.getElementById("closeButtonUser").click();
          setBtnLoading(false);
          refetchUser();
          MySwal.fire({
            position: "top-end",
            icon: "success",
            title: translation?.["created_successfully"] || "Create Successfully!",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        setBtnLoading(false);
        console.log("error", error.response.data.message);
        MySwal.fire({
          position: "top-end",
          icon: "error",
          title: error.response.data.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }
  };
  const setUserLocation = async (user) => {
    // let userStores = [];
    // let userPeerGroups = [];
    // this.dataAccessibleRows.forEach((element) => {
    //   userStores.push(element.storeNumber);
    // });
    // this.peerGroupRows.forEach((element) => {
    //   userPeerGroups.push(element._id)
    // })
    // if (userStores.length === 0) {
    //   return;
    // }
    let UsrDetails = {
      userId: user,
      locations: [
        {
          type: "mystores",
          storeCodes: checkboxData["workAt"] || [],
        },
        {
          type: "dataaccess",
          storeCodes: storesData?.map((item) => item.storeCode) || [],
        },
        {
          type: "peergroups",
          peerGroupIds: checkboxData["oversees"] || [],
        },
      ],
    };

    try {
      await setUserLocations(UsrDetails);
      setStoresData([]);
    } catch (error) {
      console.log("e:", error);
    }
  };

  const handleCheckboxChange = (storeCode, field) => {
    setCheckboxData((prevState) => {
      const fieldData = prevState[field] || [];
      const newFieldData = fieldData?.includes(storeCode)
        ? fieldData.filter((item) => item !== storeCode)
        : [...fieldData, storeCode];
      return { ...prevState, [field]: newFieldData };
    });
  };
  return (
    <div>
      {/* Add User */}
      <div className="modal fade" id="add-users">
        {/* Add Stores Modal */}
        {isModalOpen && (
          <AddStoresModal
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            onSelectStores={handleSelectStores}
            selected={storesData}
          />
        )}
        <div className="modal-dialog modal-dialog-centered modal-dialog-right modal-lg custom-modal-two" style={{ width: "750px" }}>
          <div className="modal-content" style={{ width: "750px" }}>
            <div className="page-wrapper-new p-0">
              <div className="">
                <div className="modal-header border-0 custom-modal-header">
              <div>
              <button
                    id="closeButtonUser"
                    type="button"
                    className="close modal-close-icon"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
              </div>
                  <div className="page-title">
                    <h4> {translation?.["add_user"] || "Add User"} </h4>
                  </div>
                 
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={submit}>
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{translation?.["first_name"] || "First Name"}*</label>
                          <input
                            type="text"
                            placeholder={translation?.["first_name"] || "First Name"}
                            className="form-control"
                            value={formDataList?.firstname || ""}
                            name="firstname"
                            onChange={handleInputChange}
                            ref={(el) => (inputRefs.current.firstname = el)} // Assign ref
                          />
                          {formErrors.firstname && (
                            <span className="text-danger">
                              {formErrors.firstname}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{translation?.["last_name"] || "Last Name"}</label>
                          <input
                            type="text"
                            placeholder={translation?.["last_name"] || "Last Name"}
                            className="form-control"
                            value={formDataList?.lastname || ""}
                            name="lastname"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{translation?.["user_name"] || "User Name"}*</label>
                          <input
                            placeholder={translation?.["user_name"] || "User Name"}
                            type="text"
                            className="form-control"
                            value={formDataList?.username || ""}
                            name="username"
                            onChange={handleInputChange}
                            ref={(el) => (inputRefs.current.username = el)}
                          />
                          {formErrors.username && (
                            <span className="text-danger">
                              {formErrors.username}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{translation?.["email"] || "Email"}*</label>
                          <input
                            placeholder={translation?.["email"] || "Email"}
                            type="text"
                            className="form-control"
                            value={formDataList?.email || ""}
                            name="email"
                            onChange={handleInputChange}
                            ref={(el) => (inputRefs.current.email = el)}
                          />
                          {formErrors.email && (
                            <span className="text-danger">
                              {formErrors.email}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{translation?.["password"] || "Password"}*</label>
                          <div className="pass-group">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="pass-input"
                              placeholder={
                                translation?.["enter_your_password"] ||
                                "Enter your password"
                              }
                              value={password}
                              onChange={handlePasswordChange}
                              minLength={3}
                              ref={(el) => (inputRefs.current.password = el)}
                            />
                            <span
                              className={`fas toggle-password ${
                                showPassword ? "fa-eye" : "fa-eye-slash"
                              }`}
                              onClick={handleTogglePassword}
                            />
                          </div>

                          {formErrors.password && (
                            <span className="text-danger">
                              {formErrors.password}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>
                            {translation?.["confirm_password"] || "Confirm Password"}*
                          </label>
                          <div className="pass-group">
                            <input
                              type={showConfirmPassword ? "text" : "password"}
                              className="pass-input"
                              placeholder={
                                translation?.["enter_your_password"] ||
                                "Enter your password"
                              }
                              value={confirmPassword}
                              onChange={handleConfirmPasswordChange}
                              ref={(el) =>
                                (inputRefs.current.confirmPassword = el)
                              }
                            />
                            <span
                              className={`fas toggle-password ${
                                showConfirmPassword ? "fa-eye" : "fa-eye-slash"
                              }`}
                              onClick={handleToggleConfirmPassword}
                            />
                          </div>
                          {formErrors.confirmPassword && (
                            <span className="text-danger">
                              {formErrors.confirmPassword}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{translation?.["job_title"] || "Job Title"}</label>
                          <input
                            type="text"
                            placeholder={translation?.["job_title"] || "Job Title"}
                            className="form-control"
                            value={formDataList?.jobTitle || ""}
                            name="jobTitle"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>
                            {translation?.["job_experience"] || "Job Experience"}
                          </label>
                          <input
                            placeholder={
                              translation?.["job_experience"] || "Job Experience"
                            }
                            type="text"
                            className="form-control"
                            value={formDataList?.jobExperience || ""}
                            name="jobExperience"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>
                            {translation?.["linkedin_profile"] || "LinkedIn Profile"}
                          </label>
                          <input
                            type="url"
                            placeholder={
                              translation?.["linkedin_profile"] || "LinkedIn Profile"
                            }
                            className="form-control"
                            value={formDataList?.linkedinProfile || ""}
                            name="linkedinProfile"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="input-blocks">
                          <label>
                            {translation?.["shift_start_time"] || "Shift Start Time"}
                          </label>
                          <input
                            type="time"
                            className="form-control"
                            value={formDataList?.shiftStartTime || ""}
                            name="shiftStartTime"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="input-blocks">
                          <label>
                            {translation?.["shift_end_time"] || "Shift End Time"}
                          </label>
                          <input
                            type="time"
                            className="form-control"
                            value={formDataList?.shiftEndTime || ""}
                            name="shiftEndTime"
                            onChange={handleInputChange}
                            ref={(el) => (inputRefs.current.shiftEndTime = el)}
                          />
                          {formErrors.shiftEndTime && (
                            <span className="text-danger">
                              {formErrors.shiftEndTime}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="input-blocks">
                          <label>
                            {translation?.["job_responsibilities"] ||
                              "Job Responsibilities"}
                          </label>
                          <textarea
                            placeholder= {translation?.["job_responsibilities"] ||
                              "Job Responsibilities..."}
                            className="form-control"
                            value={formDataList?.jobResponsibilities || ""}
                            name="jobResponsibilities"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="input-blocks">
                          <label>{translation?.["skill_sets"] || "Skill Sets"}</label>
                          <textarea
                            className="form-control"
                            value={formDataList?.skillSets || ""}
                            placeholder={translation?.["skill_sets_placholder"] || "Comma separated (React, Nodejs, ...)"}
                            name="skillSets"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="row col-lg-12">
                        <div className="input-blocks">
                          <label>{translation?.["role"] || "Role"}*</label>
                          <Select
                            className="select"
                            options={dataRole}
                            placeholder={
                              translation?.["select_role"] || "Select Role"
                            }
                            name="selectedRole"
                            style={{ width: "106%" }}
                            value={
                              dataRole?.find(
                                (option) =>
                                  option.value === formDataList?.selectedRole
                              ) || ""
                            }
                            onChange={(v) => {
                              handleInputChange({
                                target: {
                                  name: "selectedRole",
                                  value: v.value,
                                },
                              });
                            }}
                            ref={(el) => (inputRefs.current.selectedRole = el)}
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                width: "104%",
                              }),
                            }}
                          />
                          {formErrors.selectedRole && (
                            <span className="text-danger">
                              {formErrors.selectedRole}
                            </span>
                          )}
                        </div>
                        <div className="row col-lg-12 stores-wrapper">
                          <div className="input-blocks">
                            <label>{translation?.["stores"] || "Stores"}</label>
                            <button
                              type="button"
                              className="btn btn-store full-width"
                              onClick={handleOpenModal}
                            >
                               {translation?.["add_stores"] || "Add Stores"}
                            </button>
                          </div>
                          {/* table area  */}
                          <div className="input-blocks">
                            <table className="table">
                              <thead>
                                <tr>
                                <th> {translation?.["visible_stores"] || "Visible Stores"}</th>
                                <th> {translation?.["oversees"] || "Oversees"} </th>
                                <th>  {translation?.["works_at"] || "Works At"} </th>
                                <th> {translation?.["actions"] || "Actions"}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {storesData.map((item) => (
                                  <tr key={item.storeCode}>
                                    <td>{item.label}</td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        name="oversees"
                                        checked={
                                          checkboxData["oversees"]?.includes(
                                            item.storeCode
                                          ) || false
                                        }
                                        onChange={() =>
                                          handleCheckboxChange(
                                            item.storeCode,
                                            "oversees"
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        name="workAt"
                                        checked={
                                          checkboxData["workAt"]?.includes(
                                            item.storeCode
                                          ) || false
                                        }
                                        onChange={() =>
                                          handleCheckboxChange(
                                            item.storeCode,
                                            "workAt"
                                          )
                                        }
                                      />
                                    </td>
                                    <td
                                      onClick={() => removeMethod(item)}
                                      className="removed"
                                    >
                                      {translation?.["remove"] || "Remove"}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <div className="modal-footer-btn">
                        <button
                          type="button"
                          className="btn btn-cancel me-2"
                          data-bs-dismiss="modal"
                        >
                          {translation?.["cancel"] || "Cancel"}
                        </button>
                        <button
                          disabled={btnLoading}
                          type="submit"
                          className="btn btn-submit"
                        >
                          {/* {!btnLoading ? "Save" : "Wait..."} */}
                         {btnLoading ? translation?.wait || "Wait..." : translation?.save || "Save"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
export default AddUsers;
